import {
  NavLink,
  Link,
  useRouteLoaderData,
  Form,
  useLocation,
} from "react-router-dom";

import "./MainNavigation.css";
import { useEffect, useState } from "react";

import logoImg from "../../../assets/logo-img.svg";
import logoImgDark from "../../../assets/dark-logo.svg";
import profileImg from "../../../assets/profile-img.svg";
import securityImg from "../../../assets/security-icon.svg";
import myProfileImg from "../../../assets/my-profile-icon.svg";
import logoutImg from "../../../assets/logout-icon.svg";

import { getUserId, getAvatar, getUserRole } from "../../../auth/auth";
import { base_url } from "../../../config";

export default function MainNavigation() {
  const location = useLocation();
  const token = useRouteLoaderData("root");
  const id = getUserId();
  const role = getUserRole();
  const avatarImg = getAvatar();
  const [navActive, setNavActive] = useState(false);
  const [profileActive, setProfileActive] = useState(false);

  let profilePath = `/my-profile/${id}`;

  if (role === "company") {
    profilePath = `/company-profile/${id}`;
  }

  const handleActive = () => {
    setNavActive((prevState) => !prevState);

    if (!navActive) {
      document.querySelector("body").classList.add("active");
    } else {
      document.querySelector("body").classList.remove("active");
    }
  };

  const handleProfileMenu = () => {
    setProfileActive((prevState) => !prevState);
  };

  useEffect(() => {
    if (location.pathname === "/") {
      document.body.classList.add("homepage-light");
    } else {
      document.body.classList.remove("homepage-light");
    }
  }, [location.pathname]);

  return (
    <>
      <header
        className={`${location.pathname === "/" ? "header-homepage" : ""}`}
      >
        <div className="header-main d-flex-essy items-center-essy">
          <div className="header-main__logo">
            <Link to="/">
              <img
                src={`${location.pathname === "/" ? logoImgDark : logoImg}`}
                alt="logo"
              />
            </Link>
          </div>
          <div
            className={`header-navigation-wrapper d-flex-essy ${
              navActive ? "active" : ""
            }`}
          >
            <div className="header-main__nav d-flex-essy items-center-essy">
              <NavLink
                onClick={handleActive}
                to="/"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Home
              </NavLink>
              <NavLink
                onClick={handleActive}
                to="/about-us"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                About Us
              </NavLink>
              <NavLink
                onClick={handleActive}
                to="/faq"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                FAQ
              </NavLink>
              <NavLink
                onClick={handleActive}
                to="/support"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                Support
              </NavLink>
              {token && <NavLink to="chat">Chat</NavLink>}
              {role === "company" && (
                <NavLink onClick={handleActive} to="/my-jobs">
                  My Jobs
                </NavLink>
              )}

              {role === "employee" && (
                <>
                  <NavLink onClick={handleActive} to="/jobs">
                    Jobs
                  </NavLink>
                  <NavLink onClick={handleActive} to="/jobs/my-jobs">
                    My Jobs
                  </NavLink>
                </>
              )}
            </div>
            {token ? (
              <div className="nav-profile-account">
                <button onClick={handleProfileMenu}>
                  <img
                    src={
                      !avatarImg || avatarImg === "null"
                        ? profileImg
                        : `${base_url}${avatarImg}`
                    }
                  />
                </button>
                <div
                  className={`${
                    profileActive ? "active" : ""
                  }  nav-profile-navigation`}
                >
                  <NavLink onClick={handleProfileMenu} to="/security">
                    <img src={securityImg} />
                    Security
                  </NavLink>
                  <div className="separator"></div>
                  <NavLink to={profilePath} onClick={handleProfileMenu}>
                    <img src={myProfileImg} />
                    My Profile
                  </NavLink>
                  <div className="separator"></div>
                  <Form action="/logout" method="post">
                    <button type="submit">
                      <img src={logoutImg} />
                      Logout
                    </button>
                  </Form>
                </div>
              </div>
            ) : (
              <div className="header-main__login d-flex-essy items-center-essy">
                <Link
                  to="/login"
                  onClick={() => {
                    handleActive();
                    document.body.classList.remove("homepage-light");
                  }}
                >
                  Login
                </Link>
                <div className="separator"></div>
                <Link
                  to="/register"
                  onClick={() => {
                    handleActive();
                    document.body.classList.remove("homepage-light");
                  }}
                >
                  Register
                </Link>
              </div>
            )}
          </div>
          <div className="mobile-nav-wrapper">
            <div
              className={`mobile-hamburger ${navActive ? "active" : ""}`}
              onClick={handleActive}
            >
              <span className="line-1"></span>
              <span className="line-2"></span>
            </div>
            {token && (
              <div className="nav-profile-account">
                <button onClick={handleProfileMenu}>
                  <img
                    src={
                      !avatarImg || avatarImg === "null"
                        ? profileImg
                        : `${base_url}${avatarImg}`
                    }
                  />
                </button>
                <div
                  className={`${
                    profileActive ? "active" : ""
                  }  nav-profile-navigation`}
                >
                  <NavLink onClick={handleProfileMenu} to="/security">
                    <img src={securityImg} />
                    Security
                  </NavLink>
                  <div className="separator"></div>
                  <NavLink to={profilePath} onClick={handleProfileMenu}>
                    <img src={myProfileImg} />
                    My Profile
                  </NavLink>
                  <div className="separator"></div>
                  <Form action="/logout" method="post">
                    <button type="submit">
                      <img src={logoutImg} />
                      Logout
                    </button>
                  </Form>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
}
